import React from 'react';
import { Container, Box, Typography, Grid, Paper } from '@mui/material';
import contactus from '../assets/buildingAboutus.webp';
import chairmanImg from '../assets/chairman.webp';
import useResponsive from '../hooks/useResponsive';
import Testimonials from './Testimonials';

const Aboutus = () => {
    const { isSmallScreen } = useResponsive();

    return (
        <>
            <Container  sx={{ p: '24px 24px 0 24px', mt: 14 }}>
                {/* Section Heading */}
                <Typography variant="h3" fontWeight={600} mb={3}>
                    About Vibrant
                </Typography>

                {/* Tagline Banner */}
                <Box
                    sx={{
                        mt: 6, px: isSmallScreen ? 1 : 3, py: isSmallScreen ? 1.5 : 3,
                        borderRadius: 2, backgroundColor: '#ffb627', display: 'flex', alignItems: 'center',
                        justifyContent: 'space-between', flexDirection: isSmallScreen ? 'column' : 'row',
                        textAlign: isSmallScreen ? 'center' : 'left',
                        position: 'relative', overflow: 'visible', minHeight: isSmallScreen ? 140 : 145,
                    }}
                >
                    <Box sx={{ flex: 1, zIndex: 1 }}>
                        <Typography variant="h6" sx={{ fontStyle: 'italic', fontWeight: 500, fontSize: isSmallScreen ? 16 : 20, mt: isSmallScreen ? 4 : 0, }}>
                            Choose Vibrant Propmart
                        </Typography>
                        <Typography variant="h6" sx={{ fontStyle: 'italic', fontWeight: 500, fontSize: isSmallScreen ? 16 : 20, }}>
                            Because Your Home Deserves More Than Just a Transaction.
                        </Typography> 
                    </Box>

                    <Box component="img" loading='lazy' src={contactus} alt="Customer Support"
                        sx={{
                            position: 'absolute', right: isSmallScreen ? '50%' : 24,
                            top: isSmallScreen ? -50 : -40, maxHeight: isSmallScreen ? 100 : 290,
                            objectFit: 'contain', maxWidth: isSmallScreen ? 120 : 290,
                            zIndex: 2, transform: isSmallScreen ? 'translateX(50%)' : 'none',
                        }}
                    />
                </Box>

                {/* About + Vision */}
                <Grid container spacing={4} mt={5}>
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Typography variant='body1' fontSize={16} lineHeight={1.8}>
                            At Vibrant Propmart, we are more than just real estate advisors—we are your partners in creating a brighter future.
                            With a strong pan-India presence and years of deep-rooted experience in the Indian real estate market,
                            we offer expert guidance to help you make informed decisions in buying residential properties across the country.
                            <br /><br />
                            Founded and driven by a team of dynamic and visionary professionals, Vibrant Propmart is committed to delivering
                            personalized real estate solutions tailored to meet the unique needs of every client. Whether you're a first-time
                            homebuyer, a seasoned investor, or searching for the perfect rental, we stand with you at every step.
                        </Typography>
                    </Grid>

                    {/* Vision */}
                    <Grid size={{ xs: 12, md: 5 }}>
                        <Paper sx={{ p: 3, height: '100%', bgcolor: '#525252', color: '#fff' }}>
                            <Typography variant="h4" fontWeight={600} gutterBottom>
                                Our Vision
                            </Typography>
                            <Typography fontSize={16} lineHeight={1.7}>
                                We believe real estate isn’t just about buildings—it’s about building trust, value, and long-lasting relationships.
                                At Vibrant, we envision a future where the property journey is intelligent, transparent, and digitally enabled.
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>

                {/* Chairman + Mission */}
                <Grid container spacing={4} mt={4}>
                    {/* Chairman Card (Image Left + Text Right) */}
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, backgroundColor: '#fff', borderRadius: 2, overflow: 'hidden', height: '100%', }}>
                            {/* Image Side */}
                            <Box component="img" loading='lazy' src={chairmanImg} alt="Chairman" sx={{ width: { xs: '100%', md: '40%' }, height: '400px', objectFit: 'contain', }} />

                            {/* Text Side */}
                            <Box sx={{ p: { xs: 2, md: 3 }, flex: 1 }}>
                                <Typography variant="h4" fontWeight={600} fontSize={18} mb={1}>
                                    Message from Chairman
                                </Typography>
                                <Typography variant="body1" lineHeight={1.6}>
                                    Vibrant is an independent real estate advisor with a pan-India presence. We possess vast experience and knowledge
                                    of real estate in India, and aspire to be your first port of call if you want to buy a residential property in India.
                                    <br /><br />
                                    We possess vast experience and knowledge in residential real estate and are committed to delivering exceptional service.
                                </Typography>
                                <Box mt={2}>
                                    <Typography variant="h6" fontWeight={600} sx={{ color: '#BB081B' }}>
                                        Srinivas
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#737373' }}>
                                        Chairman at Vibrant Propmart
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                    </Grid>

                    {/* Mission Card */}
                    <Grid mt={3} size={{ xs: 12, md: 5 }}>
                        <Paper sx={{ p: 3, backgroundColor: '#ed1c24', color: '#fff' }}>
                            <Typography variant="h4" fontWeight={600} gutterBottom>
                                Our Mission
                            </Typography>
                            <Typography fontSize={16} lineHeight={1.7}>
                                1. To become the first choice for our customers and partners when it comes to discovering, buying, renting, selling, or financing property.
                                <br /><br />
                                2. We are committed to supporting our clients throughout their real estate journey by integrating:
                            </Typography>
                            <Box mt={2} pl={2}>
                                <Typography variant="body1" lineHeight={1.7}>• Smart data-driven insights</Typography>
                                <Typography variant="body1" lineHeight={1.7}>• AI-powered search and cutting-edge technology</Typography>
                                <Typography variant="body1" lineHeight={1.7}>• Comprehensive end-to-end solutions</Typography>
                                <Typography variant="body1" lineHeight={1.7}>• A passionate and professional team</Typography>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
            <Testimonials />
        </>


    );
};

export default Aboutus;
